(function () {
  "use strict";

  var root = document.querySelector("[data-thiel-toner-root]");
  if (!root) return;

  var form = root.querySelector("[data-thiel-toner-form]");
  var dialog = root.querySelector(".thiel-toner-request__dialog");
  var queryInput = root.querySelector("[data-thiel-toner-query]");
  var bodyInput = root.querySelector("[data-thiel-toner-body]");
  var statusNode = root.querySelector("[data-thiel-toner-status]");
  var submitButton = root.querySelector("[data-thiel-toner-submit]");
  var searchParams = new URLSearchParams(window.location.search);
  var debugOpen = searchParams.has("thiel_toner_popup");
  var manualHash = "#toner-nicht-gefunden";
  var storageKey = "thiel-toner-request-dismissed-until";
  var opened = false;
  var openedReason = "";

  function now() {
    return Date.now();
  }

  function dismissed() {
    if (debugOpen) return false;
    try {
      return Number(window.localStorage.getItem(storageKey) || 0) > now();
    } catch (error) {
      return false;
    }
  }

  function rememberDismissal() {
    try {
      window.localStorage.setItem(storageKey, String(now() + 24 * 60 * 60 * 1000));
    } catch (error) {}
  }

  function isBlockedPath() {
    return /\/checkout(\/|$)/.test(window.location.pathname);
  }

  function isManualReason(reason) {
    return reason === "manual" || reason === "hash" || reason === "debug";
  }

  function cleanText(value) {
    return String(value || "").replace(/\s+/g, " ").trim();
  }

  function pageTitlePrefill() {
    var title = cleanText(document.querySelector("h1")?.textContent || document.title);
    return title.replace(/\s+[-|].*$/, "");
  }

  function currentSearchTerm() {
    return cleanText(searchParams.get("q") || root.getAttribute("data-prefill") || "");
  }

  function setPrefill(reason) {
    if (!queryInput || queryInput.value) return;
    var value = reason === "debug" ? "" : cleanText(root.getAttribute("data-prefill"));
    if (!value && reason === "search-empty") value = currentSearchTerm();
    if (!value && /product/.test(reason)) value = pageTitlePrefill();
    queryInput.value = value;
  }

  function openPopup(reason) {
    if (opened && !root.hidden) return;
    if (!isManualReason(reason) && dismissed()) return;
    if (isBlockedPath()) return;
    opened = true;
    openedReason = reason || "manual";
    setPrefill(openedReason);
    root.hidden = false;
    document.body.classList.add("thiel-toner-request-open");
    window.setTimeout(function () {
      var firstInput = queryInput && !queryInput.value ? queryInput : root.querySelector("input[required], button");
      if (firstInput && typeof firstInput.focus === "function") firstInput.focus({ preventScroll: true });
      if (dialog && typeof dialog.focus === "function") dialog.focus({ preventScroll: true });
    }, 40);
  }

  function closePopup() {
    root.hidden = true;
    opened = false;
    document.body.classList.remove("thiel-toner-request-open");
    rememberDismissal();
  }

  function productLooksUnavailable() {
    if (!/\/products\//.test(window.location.pathname)) return false;
    if (root.getAttribute("data-product-available") === "false") return true;

    var buttons = Array.prototype.slice.call(
      document.querySelectorAll('button[name="add"], form[action*="/cart/add"] button[type="submit"]')
    );
    return buttons.some(function (button) {
      var text = cleanText(button.textContent).toLowerCase();
      if (!button.disabled && button.getAttribute("aria-disabled") !== "true") return false;
      return /ausverkauft|nicht verfuegbar|nicht verf\u00fcgbar|sold out|unavailable/.test(text);
    });
  }

  function canUseExitIntent() {
    if (opened || dismissed() || debugOpen || isBlockedPath()) return false;
    if (!/\/(search|products)\b/.test(window.location.pathname)) return false;
    return window.matchMedia("(pointer: fine)").matches;
  }

  function scheduleTriggers() {
    if (debugOpen) {
      window.setTimeout(function () {
        openPopup("debug");
      }, 250);
      return;
    }

    if (window.location.hash === manualHash) {
      window.setTimeout(function () {
        openPopup("hash");
      }, 150);
    }
  }

  function setStatus(message, state) {
    if (!statusNode) return;
    statusNode.textContent = message;
    statusNode.classList.remove("is-success", "is-error");
    if (state) statusNode.classList.add("is-" + state);
  }

  function composeBody() {
    var data = new FormData(form);
    var toner = cleanText(queryInput ? queryInput.value : data.get("contact[name]"));
    return [
      "Toner-Anfrage",
      "",
      "Gesuchter Toner / Drucker: " + toner,
      "Auslöser: " + openedReason,
      "Seite: " + window.location.href,
      "Zeitpunkt: " + new Date().toISOString(),
      "",
      "Hinweis: Anfrage kam über das Thiel-Toner-Popup. Bitte manuell Bestand, Preis und Alternative prüfen.",
    ].join("\n");
  }

  function submitForm(event) {
    event.preventDefault();
    if (!form || !bodyInput) return;

    bodyInput.value = composeBody();
    if (submitButton) {
      submitButton.disabled = true;
      submitButton.textContent = "Wird gesendet...";
    }
    setStatus("Einen Moment, wir übergeben Ihre Anfrage.", "");

    fetch("/contact", {
      method: "POST",
      body: new URLSearchParams(new FormData(form)),
      headers: {
        Accept: "text/html",
        "Content-Type": "application/x-www-form-urlencoded",
      },
      credentials: "same-origin",
    })
      .then(function (response) {
        if (!response.ok) throw new Error("Kontaktformular nicht angenommen.");
        setStatus("Danke. Ihre Anfrage ist angekommen, wir melden uns schnellstmöglich.", "success");
        if (submitButton) submitButton.textContent = "Anfrage gesendet";
        rememberDismissal();
      })
      .catch(function () {
        setStatus("Bitte kurz neu versuchen oder direkt an info@thiel-shop.de schreiben.", "error");
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.textContent = "Express-Angebot anfordern";
        }
      });
  }

  root.addEventListener("click", function (event) {
    if (event.target.closest("[data-thiel-toner-close]")) closePopup();
  });

  document.addEventListener("click", function (event) {
    var trigger = event.target.closest("[data-thiel-toner-open], a[href='" + manualHash + "']");
    if (!trigger) return;
    event.preventDefault();
    openPopup("manual");
  });

  window.addEventListener("hashchange", function () {
    if (window.location.hash === manualHash) openPopup("hash");
  });

  document.addEventListener("keydown", function (event) {
    if (!opened || root.hidden) return;
    if (event.key === "Escape") closePopup();
  });

  if (form) form.addEventListener("submit", submitForm);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scheduleTriggers);
  } else {
    scheduleTriggers();
  }
})();
